import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UploadImageComponent } from 'src/app/dashboard/upload-image/upload-image.component';
@Component({
  selector: 'media-image-selector',
  templateUrl: './media-image-selector.component.html',
  styleUrls: ['./media-image-selector.component.scss']
})
export class MediaImagesSelectorComponent implements OnInit {

  @Input() imgURL: string = undefined;
  @Input() mediaID: string | number = undefined;
  @Input() showClearButton: boolean = false;
  @Input() labelText: string = 'Upload Image';

  @Output() imgURLChange: EventEmitter<any> = new EventEmitter();
  @Output() mediaIDChange: EventEmitter<any> = new EventEmitter();

  @Output() mediaChanged: EventEmitter<any> = new EventEmitter();

  constructor(
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void { }

  openUploader() {
    const modalRef = this.modalService.open(UploadImageComponent, { size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.id = 10;
    modalRef.componentInstance.labelText = this.labelText;
    modalRef.result.then((result) => {
      //console.log(result);
      if (result != 'Modal Closed') {

        this.imgURL = result[0];
        this.mediaID = result[1];

        this.imgURLChange.emit(result[0])
        this.mediaIDChange.emit(result[1])

        this.mediaChanged.emit({
          url: result[0],
          mediaId: result[1]
        })

      }
    }).catch((error) => {
      console.log(error);
    });
  }

  clearSelected() {
    this.imgURL = '';
    this.mediaID = '';

    this.imgURLChange.emit('')
    this.mediaIDChange.emit('')

    this.mediaChanged.emit({
      url: '',
      mediaId: ''
    })
  }



}
